<template>
  <v-row
    align="center"
    justify="start"
    no-gutters
  >
    <v-col
      cols="2"
      sm="3"
      md="6"
      lg="4"
      xl="2"
      class="pa-1"
      v-for="source in params.value"
      :key="source"
    >
      <v-img
        contain
        :source="source"
        :src="targetImage(source)"
        aspect-ratio="1"
      ></v-img>
    </v-col>
  </v-row>
</template>

<script>
  import AMRLD from '@/assets/dataSources/AMRLD-Selected.png'
  import MRI from '@/assets/dataSources/MRI-Selected.png'
  import NCS from '@/assets/dataSources/Ncs-Selected.png'
  import EpsilonImg from '@/assets/dataSources/Epsilon-Selected.png'
  import AudienceMattersTarget from '@/assets/targetImages/Audience_Matters_Target.png'
  import Xandr from '@/assets/targetImages/XandrIcon.png'
  import AdstraImg from '@/assets/targetImages/AdstraIcon.png'
  import { TARGET_TYPE, DATASOURCES } from '@/appLogic/targets/Constants'
  import PIDTargetImg from '@/assets/fileTypes/PID-Selected.png'
  import NPowerImg from '@/assets/fileTypes/NPower-Selected.png'
  import ComscoreImg from '@/assets/fileTypes/Comscore-Selected.png'
  import PrismImg from '@/assets/dataSources/Prism-Selected.png'
  import BYODImg from '@/assets/dataSources/BYOD-Selected.png'
  import DNBImg from '@/assets/dataSources/DNB-Selected.png'
  import MaxImg from '@/assets/dataSources/Max-Selected.png'
  import VideoampImg from '@/assets/dataSources/Videoamp-Selected.png'
  import TVEImg from '@/assets/dataSources/TVE-Selected.png'
  import DiscoveryPlusImg from '@/assets/dataSources/DiscoveryPlus-Selected.png'
  import DCRImg from '@/assets/dataSources/DCR-Selected.png'

  export default {
    methods: {
      targetImage(source) {
        if (source === DATASOURCES.AMRLD) {
          return AMRLD
        } else if (source === DATASOURCES.MRI) {
          return MRI
        } else if (source === DATASOURCES.NCS) {
          return NCS
        } else if (source === DATASOURCES.EPSILON) {
          return EpsilonImg
        } else if (source === DATASOURCES.COMSCORE_TV) {
          return ComscoreImg
        } else if (source === DATASOURCES.NIELSEN) {
          return NPowerImg
        } else if (source === DATASOURCES.PID) {
          return PIDTargetImg
        } else if (source === DATASOURCES.COMSCORE) {
          return ComscoreImg
        } else if (source === DATASOURCES.XANDR || source === DATASOURCES.FILE) {
          return Xandr
        } else if (this.params.value === TARGET_TYPE.XANDR_SEGMENT) {
          return Xandr
        } else if (source === DATASOURCES.ADSTRA || source === 'adstra') {
          return AdstraImg
        } else if (source === DATASOURCES.PRISM) {
          return PrismImg
        } else if (source === DATASOURCES.BYOD) {
          return BYODImg
        } else if (source === DATASOURCES.DNB) {
          return DNBImg
        } else if (source === DATASOURCES.MAX) {
          return MaxImg
        } else if (source === DATASOURCES.VIDEOAMP) {
          return VideoampImg
        } else if (source === DATASOURCES.TVE) {
          return TVEImg
        } else if (source === DATASOURCES.DISCOVERY_PLUS) {
          return DiscoveryPlusImg
        } else if (source === DATASOURCES.DCR) {
          return DCRImg
        } else {
          return AudienceMattersTarget
        }
      },
    },
  }
</script>

<style></style>



// WEBPACK FOOTER //
// TargetRenderer.vue?451df22c